export { ChartLegend, type ChartLegendProps } from './ChartLegend';
